<div class="login-wrapper">
  <div class="login-card">
    <div class="logo-container">
      <img src="assets/images/Labtech_Logo.jpg" alt="LabTech Logo" />
    </div>

    <!-- STEP: CHOICE -->
    @if (step === 'choice') {
    <h2 class="choice-title">Choose your login method</h2>

    <button class="choice-btn mfa-btn" (click)="selectMfaLogin()">
      <span class="btn-icon">🔐</span>
      <div class="btn-content">
        <h3>Login with MFA</h3>
        <p>Username + Authenticator</p>
      </div>
    </button>

    <div class="divider"><span>OR</span></div>

    <button class="choice-btn azure-btn" (click)="loginWithAzure()" [disabled]="loading">
      <span class="btn-icon">🔵</span>
      <div class="btn-content">
        <h3>Login with Microsoft</h3>
        <p>Azure Active Directory</p>
      </div>
      @if (loading) {
      <span class="spinner"></span>
      }
    </button>
    }

    <!-- STEP: CREDENTIALS -->
    @if (step === 'credentials') {
    <div class="form-group">
      <label class="form-label">Username</label>
      <input type="text" class="form-control" [(ngModel)]="username" placeholder="Enter username" [disabled]="loading"
        autocomplete="username" (keyup.enter)="login()">
    </div>

    <div class="form-group">
      <label class="form-label">Password</label>
      <input type="password" class="form-control" [(ngModel)]="password" placeholder="Enter password"
        [disabled]="loading" autocomplete="current-password" (keyup.enter)="login()">
    </div>

    <button class="btn-primary" (click)="login()" [disabled]="loading">
      {{ loading ? 'Signing in...' : 'Sign in' }}
    </button>

    <button class="btn-secondary mt-2" (click)="goBack()">← Back</button>
    }

    <!-- STEP: MFA VERIFY -->
    @if (step === 'mfaVerify') {
    <p class="mfa-title">🔐 Enter your 6-digit code</p>

    <div class="form-group">
      <input type="text" class="form-control mfa-code-input" [(ngModel)]="mfaCode" placeholder="000000"
        [disabled]="loading" autocomplete="one-time-code" (keyup.enter)="verifyMfa()">
    </div>

    <button class="btn-primary" (click)="verifyMfa()" [disabled]="loading || mfaCode.length !== 6">
      {{ loading ? 'Verifying...' : 'Verify' }}
    </button>

    <button class="btn-secondary mt-2" (click)="goBack()">← Back</button>
    }

    <!-- STEP: MFA SETUP -->
    @if (step === 'mfaSetup' && mfaSetup) {
    <div class="setup-step">
      <h3>📱 Scan QR Code</h3>

      <div class="qr-code-wrapper">
        <img [src]="mfaSetup.qrCode" alt="QR Code" class="qr-code">
      </div>

      <div class="instructions">
        <ol>
          <li>Open <strong>Microsoft Authenticator</strong></li>
          <li>Tap <strong>+</strong> → <strong>"Work account"</strong></li>
          <li>Scan this QR code</li>
        </ol>
        <p><strong>Or enter manually:</strong></p>
        <div class="secret-box">
          <button class="btn-secondary" style="width: auto !important;" (click)="copySecret()">📋</button>
          <code>{{ mfaSetup.secret }}</code>
        </div>
      </div>



      <div class="form-group">
        <label class="form-label">Enter 6-digit code:</label>
        <input type="text" class="form-control mfa-code-input" [(ngModel)]="mfaCode" placeholder="000000" maxlength="6"
          [disabled]="loading" (keyup.enter)="enableMfa()">
      </div>

      <button class="btn-primary" (click)="enableMfa()" [disabled]="loading || mfaCode.length !== 6">
        {{ loading ? 'Verifying...' : 'Enable MFA & Sign in' }}
      </button>
    </div>
    }

    <!-- STEP: BACKUP CODES -->
    @if (step === 'backupCodes') {
    <div class="backup-codes-section">
      <h3>MFA successfully enabled!</h3>

      <div class="backup-codes">
        <h4>🔑 Save these backup codes:</h4>
        <p class="backup-info">
          If you lose your phone, you can use these codes to sign in.
        </p>
        <div class="codes-grid">
          @for (code of backupCodes; track code) {
          <code>{{ code }}</code>
          }
        </div>
        <button class="btn-secondary" (click)="downloadBackupCodes()">
          💾 Download codes
        </button>
      </div>

      <button class="btn-primary" (click)="continueToApp()">
        Continue to app
      </button>
    </div>
    }

    <!-- ERROR -->
    @if (error) {
    <div class="error-message">⚠ {{ error }}</div>
    }
  </div>
</div>